"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var library_airtable_cms_text_1 = require("@talus-analytics/library.airtable.cms-text");

var _1 = require("./");

var CookieConsent = function CookieConsent() {
  var siteMetadataContext = (0, react_1.useContext)(_1.SiteMetadataContext); // check for context provider

  if (siteMetadataContext === null) {
    throw new Error('No data found in SiteMetadataContext. Does a parent component ' + '(most likely <Layout /> or <Providers />) include the ' + '<SiteMetadataProvider /> component, and is that component ' + 'passed a result from the useSiteMetadata() hook?');
  } // extract data from context


  var data = siteMetadataContext.data,
      trackingId = siteMetadataContext.trackingId; // cookie consent stuff

  var cookieMessage = (0, library_airtable_cms_text_1.getCMSText)(data, 'Cookie consent message'),
      buttonColor = (0, library_airtable_cms_text_1.getCMSText)(data, 'Cookie consent button color'),
      backgroundColor = (0, library_airtable_cms_text_1.getCMSText)(data, 'Cookie consent background color');
  return trackingId ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("script", {
    src: "https://cdn.jsdelivr.net/npm/cookieconsent@3/build/cookieconsent.min.js",
    "data-cfasync": "false"
  }), react_1.default.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      /**\n       * If consent is given for cookies, add gtag cookies\n       * @method setupGA\n       * @return {[type]} [description]\n       */\n      function setupGA(allowed) {\n        if (!allowed) {\n          window[\"ga-disable-".concat(trackingId, "\"] = true;\n        } else {\n          window[\"ga-disable-").concat(trackingId, "\"] = false;\n          /**\n           * Helper function for defining gtag cookies\n           * @method gtag\n           * @return {[type]} [description]\n           */\n          function gtag() {\n            dataLayer.push(arguments);\n          }\n          gtag(\"js\", new Date());\n          gtag(\"config\", \"").concat(trackingId, "\");\n        }\n      }\n      window.cookieconsent.initialise({\n        palette: {\n          popup: {\n            background: \"").concat(backgroundColor, "\",\n          },\n          button: {\n            background: \"").concat(buttonColor, "\",\n          }\n        },\n        autoOpen: true,\n        position: \"bottom-right\",\n        type: \"opt-in\",\n        content: {\n          message: \"").concat(cookieMessage, "\"\n        },\n        hasTransition: false,\n        // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out\n        onInitialise: function(status) {\n          var type = this.options.type;\n          var didConsent = this.hasConsented();\n          if (type == \"opt-in\" && didConsent) {\n            // enable cookies\n            setupGA(true);\n          }\n          if (type == \"opt-out\" && !didConsent) {\n            // disable cookies\n            setupGA(false);\n          }\n        },\n        onStatusChange: function(status, chosenBefore) {\n          var type = this.options.type;\n          var didConsent = this.hasConsented();\n          if (type == \"opt-in\" && didConsent) {\n            // enable cookies\n            setupGA(true);\n          }\n          if (type == \"opt-out\" && !didConsent) {\n            // disable cookies\n            setupGA(false);\n          }\n        },\n        onRevokeChoice: function() {\n          var type = this.options.type;\n          if (type == \"opt-in\") {\n            // disable cookies\n            setupGA(false);\n          }\n          if (type == \"opt-out\") {\n            // enable cookies\n            setupGA(true);\n          }\n        }\n      });")
    }
  })) : react_1.default.createElement(react_1.default.Fragment, null);
};

exports.default = CookieConsent;